module.exports = __webpack_public_path__ + "img/Stapel2produktionsfasen.e3a180d2.png";